import { BreedersSearchByType } from 'dogpark/types';
import { apiBreeder } from 'utilities/http/api/dogPark/apiBreeder';

export const getBreeders = async (
  searchBy: BreedersSearchByType | undefined,
  searchValue: string | undefined,
) => {
  if (searchBy && searchValue) {
    const resp = await apiBreeder.getBreeder(Number(searchValue));

    if (!resp.isOk) {
      throw Error(`Breeder id ${searchValue} not found`);
    }

    return [resp.json.breeder];
  } else {
    return [];
  }
};
